import React from "react";
import { ClosingWords } from "./ClosingWords";
import { CtaButton } from "./CtaButton";
import { MockupLink } from "./MockupLink";
export function FinalClose() {
  return <section className="w-full border-t border-navy/10 bg-white px-5 py-14 md:py-20" data-id="element-97" data-mp="zmxugmlcmr81">
      <div className="mx-auto max-w-3xl text-center" data-id="element-98" data-mp="zl39j8a2uz3y">
        <p className="font-display text-xs font-extrabold uppercase tracking-[0.2em] text-navy/60" data-id="element-99" data-mp="14kzaeynhaafa">One last question</p>
        <p className="mt-4 text-lg leading-relaxed text-navy md:text-xl" data-id="element-100" data-mp="703dhznqq9zb">
          How many times have you worked with a pregnant client and known the training goal — but still had to decide which exercise variation to use, how much
          volume to prescribe or what should change as pregnancy progressed?
        </p>
        <div className="mx-auto mt-5 max-w-2xl space-y-2 text-base text-navy/80" data-id="element-101" data-mp="lozkdte29gyc">
          <p data-id="element-102" data-mp="3kcwri10uvfvv">You can keep building prenatal sessions from disconnected exercises and individual notes.</p>
          <p className="font-semibold text-navy" data-id="element-103" data-mp="3pa56jsqpj3sw">Or you can open one structured professional system covering the complete 40 weeks.</p>
        </div>

        <ClosingWords words={["Assess.", "Plan.", "Adapt.", "Coach."]} className="mt-8" data-id="element-104" data-mp="1zolkipsr4baa" />

        <MockupLink className="mx-auto mt-8 max-w-[200px] md:max-w-[240px]" data-id="element-105" data-mp="1uxmyd9l30iz4" />

        <div className="mt-6 flex justify-center" data-id="element-106" data-mp="1pz1zbdhkg5c9">
          <CtaButton label="Get Prenatal Training Pro 2026" data-id="element-107" data-mp="1pyit2u1a35e2" />
        </div>
      </div>
    </section>;
}